/* CAFFREY Revive Delicate Cream: page behaviour (launch build · Claude Code, launch agent, builder, WORKFLOW-P, 2026-10-08).
   Replaces cf-lc.js on templates/product.leather-cream.json. Add to cart, Shop Pay, the delivery line and the sticky bar are
   the CAFFREY kit's (cf-kit.js + Dawn's product-form); this file only does three small things:
   1. Speed: the pictures under the first screen wait in <noscript data-lc-defer>, and the display serif (Libre Bodoni 500 +
      italic, [data-lc-fonts]) waits too, until the hero photograph has loaded (4 s at the latest), so on a slow phone they
      don't share the line with the page's largest paint. Picture boxes are reserved by aspect-ratio and the H1's line boxes
      are fixed, so nothing moves when they arrive. A shopper who scrolls, taps or presses a key first gets them at once.
      Without JavaScript the browser shows the pictures and loads the fonts from the <noscript> @font-face rules.
   2. Hero pictures: two slides with native scroll-snap (swipe, trackpad, arrow keys); the dots show and choose the slide.
   3. Zoom: the "+" button opens the real packshot (catalog image 1) at its native 1080 px in a dialog; without
      JavaScript the same link opens the image itself. */
(() => {
  if (window.CaffreyLeatherCream) { window.CaffreyLeatherCream.run(); return; }

  /* 1. hold below-the-fold pictures and the display serif until the hero has loaded */
  let fontsAdded = false;
  const loadFonts = () => {
    const el = document.querySelector('[data-lc-fonts]');
    if (fontsAdded || !el || !document.fonts || typeof FontFace === 'undefined') return;
    fontsAdded = true;
    let cfg = {};
    try { cfg = JSON.parse(el.textContent) || {}; } catch (e) { return; }
    // Shopify's font.family arrives CSS-quoted ("Libre Bodoni"); FontFace takes the bare family name.
    const family = String(cfg.family || '').trim().replace(/^["']+|["']+$/g, '');
    (cfg.faces || []).forEach(f => {
      if (!f || !f.url || !family) return;
      const face = new FontFace(family, `url("${f.url}") format("woff2")`, { weight: String(f.weight || 400), style: f.style || 'normal', display: 'swap' });
      document.fonts.add(face);
      face.load().catch(() => {});
    });
  };

  let released = false;
  const release = () => {
    loadFonts();
    if (released) return;
    released = true;
    document.querySelectorAll('noscript[data-lc-defer]').forEach(ns => {
      const html = ns.textContent;
      if (html && html.indexOf('<img') !== -1) ns.insertAdjacentHTML('beforebegin', html);
      ns.remove();
    });
  };
  const holdUntilHero = () => {
    const hero = document.querySelector('.lc-hero__slide img');
    if (!hero || (hero.complete && hero.naturalWidth > 0)) { release(); return; }
    hero.addEventListener('load', release, { once: true });
    hero.addEventListener('error', release, { once: true });
    ['scroll', 'touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(type =>
      window.addEventListener(type, release, { once: true, passive: true, capture: true }));
    setTimeout(release, 4000);
  };

  /* 2. hero slides */
  const initSlides = root => {
    const track = root.querySelector('[data-lc-slides]');
    const dots = root.querySelector('[data-lc-dots]');
    if (!track || !dots || track.dataset.lcReady) return;
    const slides = [...track.querySelectorAll('[data-lc-slide]')];
    const buttons = [...dots.querySelectorAll('[data-lc-dot]')];
    if (slides.length < 2 || buttons.length !== slides.length) return;
    track.dataset.lcReady = 'true';
    dots.hidden = false;
    const current = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    const mark = () => {
      const i = current();
      buttons.forEach((b, n) => b.setAttribute('aria-current', n === i ? 'true' : 'false'));
    };
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    buttons.forEach((b, n) => b.addEventListener('click', () => {
      track.scrollTo({ left: n * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }));
    let frame = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(mark);
    }, { passive: true });
    window.addEventListener('resize', mark, { passive: true });
    mark();
  };

  /* 3. zoom dialog */
  const initZoom = root => {
    const trigger = root.querySelector('[data-lc-zoom]');
    const dialog = root.querySelector('[data-lc-dialog]');
    if (!trigger || !dialog || typeof dialog.showModal !== 'function' || trigger.dataset.lcReady) return;
    trigger.dataset.lcReady = 'true';
    trigger.addEventListener('click', e => {
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button === 1) return;
      e.preventDefault();
      dialog.showModal();
    });
    const close = dialog.querySelector('[data-lc-close]');
    if (close) close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
  };

  const run = () => {
    holdUntilHero();
    document.querySelectorAll('[data-lc-hero]').forEach(root => { initSlides(root); initZoom(root); });
  };
  document.addEventListener('shopify:section:load', () => { released = false; run(); });
  window.CaffreyLeatherCream = { run };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
